
import EditorImage from 'Editors/EditorImage'
import EditorTipTap from 'Editors/EditorTipTap'
import Product from '@/components/ecommerce/shop/product/product'
import FourColSkeleton from '@/components/animations/skeletor-elements/skeleton-element-four-col'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    EditorImage,
    Product,
    // eslint-disable-next-line vue/no-unused-components
    EditorTipTap,
    // eslint-disable-next-line vue/no-unused-components
    FourColSkeleton,
  },
  data() {
    return {
      inView: false,
      loading: true,
      swiperOptions: {
        slidesPerGroup: 4,
        slidesPerView: 4,
        spaceBetween: 28,
        observer: true,
        observeParents: true,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'custom',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          1280: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 28,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 10,
          },
          540: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 10,
          },
          375: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
          },
          0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
          },
        },
      },
      options: [
        {
          name: 'title',
          label: 'Name',
          type: 'tipTap',
        },
        {
          name: 'description',
          label: 'Action price',
          type: 'tipTap',
        },
        {
          name: 'description2',
          label: 'Price',
          type: 'tipTap',
        },
        {
          name: 'discount',
          label: 'Discount',
          type: 'tipTap',
        },
        {
          name: 'logo',
          label: 'Logo',
          type: 'image',
        },
        {
          name: 'link',
          label: 'Poveznica',
          type: 'link',
        },
      ],
    }
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs.featuredProductsController.status.pending
      },
      (v) => {
        if (!v) this.loading = false
      }
    )
    setTimeout(() => {
      if (
        this.$refs.featuredProductsController &&
        this.$refs.featuredProductsController.products.length &&
        !this.$refs.featuredProductsController.status.pending
      ) {
        this.loading = false
      }
    }, 500)
  },
  methods: {
    currencyNameSwitch(price) {
      if (!price) return
      return price.replace('HRK', 'Kn')
    },
  },
}
